var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6,
    stroke: "#2C2C2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 4.6665H6.16667C5.85725 4.6665 5.5605 4.78942 5.34171 5.00821C5.12292 5.22701 5 5.52375 5 5.83317C5 6.14259 5.12292 6.43934 5.34171 6.65813C5.5605 6.87692 5.85725 6.99984 6.16667 6.99984H7.83333C8.14275 6.99984 8.4395 7.12275 8.65829 7.34155C8.87708 7.56034 9 7.85708 9 8.1665C9 8.47592 8.87708 8.77267 8.65829 8.99146C8.4395 9.21025 8.14275 9.33317 7.83333 9.33317H5",
    stroke: "#2C2C2C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollerIcon);
export default __webpack_public_path__ + "static/media/dollerIcon.c16b7333cf2160d9b63d69b691c3a8d1.svg";
export { ForwardRef as ReactComponent };